import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex-wrap;
    border-width: 1px;
    margin: 10px;
    flex-direction: row;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    align-self: center;
    align-content: center;
`;

const Label = styled.small`
    align-self: left;

`;

const Input = styled.input`
    padding: 13px;
    width: 222px;
    text-align: center;
    align-self: center;

    :hover {
        cursor: pointer;
}`;

interface IProps {
  label: string;
  value?: string;
  onChange: (key: string, value: string) => void;
}

const NumberInput: React.FC<IProps> = ({ label, onChange }) => {
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(label, event.target.value);
  };

  return (
    <Container>
      <Label>{label}</Label>
      <br />
      <Input type="number" name="name" placeholder="0" autoComplete="off" onChange={onInputChange} />
    </Container >
  );
};

export default NumberInput;
